import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'app/shared/shared.module';

import { AdminSelectFormComponent } from 'app/forms/components/admin-select-form/admin-select-form.component';
import { AppFeaturesFormComponent } from 'app/forms/components/app-features-form/app-features-form.component';
import { AppGeneralFormComponent } from 'app/forms/components/app-general-form/app-general-form.component';
import { AwsSettingsFormComponent } from 'app/forms/components/aws-settings-form/aws-settings-form.component';
import { MobileLoginFormComponent } from 'app/forms/components/mobile-login-form/mobile-login-form.component';
import { PushSettingsFormComponent } from 'app/forms/components/push-settings-form/push-settings-form.component';
import { AppBuilderService } from 'app/forms/services/app-builder/app-builder.service';
import { ImageUploadService } from 'app/shared/services/image-upload/image-upload.service';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    SharedModule,
    ReactiveFormsModule
  ],
  declarations: [
    AdminSelectFormComponent,
    AppFeaturesFormComponent,
    AppGeneralFormComponent,
    AwsSettingsFormComponent,
    MobileLoginFormComponent,
    PushSettingsFormComponent
  ],
  exports: [
    AdminSelectFormComponent,
    AppFeaturesFormComponent,
    AppGeneralFormComponent,
    AwsSettingsFormComponent,
    MobileLoginFormComponent,
    PushSettingsFormComponent
  ],
  providers: [
    ImageUploadService
  ]
})
export class TogglitFormsModule { }



// WEBPACK FOOTER //
// /app/src/app/forms/tog-forms.module.ts